/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @next/next/no-img-element */
import styles from '@buddieshr/styles/linky/Home.module.scss';
import MetaHeader from '@buddieshr/components/metaHeader';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import Header from '@buddieshr/components/header';
import Footer from '@buddieshr/components/footer';
import TextColored from '@buddieshr/components/text/textColored';
import AddToSlackButton from '@buddieshr/components/addToSlackButton';
import PageWrapper from '@buddieshr/components/templates/pageWrapper';
import { Tag } from 'antd';
import Features from '@buddieshr/components/app/features';
import Benefits from '@buddieshr/components/benefits';
import InstallNow from '@buddieshr/components/installNow';
import GetStarted from '@buddieshr/components/app/getStarted';
import Rated from '@buddieshr/components/rated';
import G2Logos from '@buddieshr/components/g2Logos';
import TrustedBy from '@buddieshr/components/trustedBy';
import { PRODUCTS } from '@buddieshr/utils/constants-products';
import PricingButtonHint from '@buddieshr/components/pricing/pricingbuttonHint';
import BuddieshrAppList from '@buddieshr/components/buddieshrAppList';
import LogoApp from '@buddieshr/components/app/logoApp';
import Image from 'next/image';

export default function Home() {
  const { t } = useTranslation();
  const router = useRouter();

  const app = PRODUCTS.find((c) => c.id === 'Linky');
  return (
    <>
      <MetaHeader
        title={t('metaTitleLinky')}
        description={t('descriptionContentLinky')}
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/linky`}
        currentShare={`https://buddieshr.com/img/apps/${app.slug}/share_preview_1.png`}
        locale={router.locale}
        pageSlug={app.slug}
      />
      <Header app={app} />
      <main className={styles.main} style={{ background: app.backgroundColor }}>
        <PageWrapper width={1500}>
          <div className={styles.firstSectionWrapper}>
            <LogoApp
              app={app}
              removeBack
              withText
              withSubtitle
              removeByBuddies
              wrapperStyle={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 36,
                maxWidth: '100%',
              }}
              style={{
                textAlign: 'left',
                margin: 'auto',
                border: '2px solid #0000000a',
                borderRadius: '10px',
                padding: '6px 12px',
                paddingBottom: '8px',
                transform: 'scale(1.2)',
                maxWidth: 'calc(100% - 40px)',
              }}
            />
            <div className={styles.tagWrapper}>
              <Tag color={app.tagColor} className={styles.tag}>
                EMPLOYEE DIRECTORY
              </Tag>
            </div>
            <h1 className={styles.mainTitle}>
              <TextColored app={app}>Build</TextColored> your{' '}
              <TextColored app={app}>Org-Chart</TextColored> in seconds
            </h1>
            <div className={styles.subtitle}>
              {'Store any employee data.'}
              <br />
              Have a clear view on teams and department
            </div>
            <div className={styles.subtitleQuote}>
              Linky is not just the best org chart in Slack — it's the best org
              chart, PERIOD.
            </div>
            <div className={styles.ratedWrapper}>
              <Rated />
            </div>
            <div className={styles.actions}>
              <AddToSlackButton app={app} />
              <PricingButtonHint />
            </div>
          </div>
        </PageWrapper>
        <TrustedBy hideInstall withoutBackground />
        <br />
        <div className={styles.demoWrapper}>
          <Image
            src="/img/apps/linky/demo.gif"
            alt="Linky demo"
            width={1280}
            height={720}
            style={{
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.16)',
            }}
          />
        </div>

        <br />
        <br />
        <PageWrapper>
          <div className={styles.benefitsWrapper}>
            <Benefits app={app} />
          </div>
          <G2Logos />
          <div className={styles.featureWrapper} id="features">
            <Features app={app} />
          </div>
          <GetStarted app={app} />
          <div className={styles.installWrapper}>
            <InstallNow
              app={app}
              gradient={app.gradient}
              title="Ready to build your org-chart?"
              subtitle="Install now get your Org Chart ready to share today."
            />
          </div>
        </PageWrapper>
        <div>
          <BuddieshrAppList appToHide={app.slug} />
        </div>
      </main>
      <Footer app={app} />
    </>
  );
}
